export enum SetupFields {
    Practice = "practice",
}